var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "loader-container",
    },
    [
      _c("div", { staticClass: "loader-backdrop" }),
      _c("div", { staticClass: "loader center-align" }, [
        _vm._m(0),
        _c("div", { key: _vm.updateKey, staticClass: "text-center" }, [
          _c("h3", [
            _vm._v(" " + _vm._s(_vm.$t("SpinnerLoadMessage.title")) + " "),
          ]),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.longLoading,
                  expression: "longLoading",
                },
              ],
            },
            [_vm._v(" " + _vm._s(_vm.$t("SpinnerLoadMessage.subTitle")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "bar-container" }, [
      _c("div", { staticClass: "bar" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }